export default {"src":"/_next/static/media/op-cp.de091ac8.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};